type DateSeparatorProps = {
  separator?: string;
};

export function DateSeparator({ separator = '/' }: DateSeparatorProps) {
  return (
    <div className="flex items-center justify-center text-text-placeholder txt-medium-regular select-none shrink-0 px-0.5">
      {separator}
    </div>
  );
}
